import React, { useState } from 'react';
import Grid from '@mui/material/Grid';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import Fab from '@mui/material/Fab';
import { createSearchParams, useSearchParams } from 'react-router-dom';

import NavigationIcon from '@mui/icons-material/Navigation';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import MapIcon from '@mui/icons-material/Map';
import sometext from '../data/placeholderText.json';
import SearchResults from '../components/Cards/SearchResults';
import LeafletMap from '../components/mapping/LeafletMap';
import MainAppBar from '../components/AppBar/MainAppBar';
import SearchAppBar from '../components/AppBar/SearchAppBar';

export default function Main() {
	const isDesktop = useMediaQuery('(min-width:600px)');
	const [dialogParams, setdialogParams] = useSearchParams();
	const [searchParams, setSearchParams] = useSearchParams();

	console.log('Main renders');
	const [isMapView, setIsMapView] = useState(true);

	const setParamToDialog = (params: string) => {
		console.log(searchParams.get('searchQuery'));
		const searchQuery = searchParams.get('searchQuery') || '';
		setdialogParams(
			createSearchParams({
				searchQuery,
				rand2: JSON.stringify(params),
			})
		);
	};

	return (
		<div>
			<MainAppBar />
			<SearchAppBar />
			<Grid container spacing={0}>
				{
					// (!isMapView || isDesktop) &&
					<Grid
						item
						md={4}
						style={{
							height: 'calc(100vh - 64px)',
							overflow: 'scroll',
							display: !isMapView || isDesktop ? 'block' : 'none',
						}}
					>
						<SearchResults setParamToDialog={setParamToDialog} />
						<Box m="10px">{sometext.text}</Box>
					</Grid>
				}
				<Grid item xs={12} sm={12} md={8}>
					<Box ml={isDesktop ? 2 : 0} mr={isDesktop ? 2 : 0} sx={{}}>
						<LeafletMap />
					</Box>
				</Grid>
			</Grid>
			{!isDesktop &&
				(isMapView ? (
					<Fab
						variant="extended"
						sx={{
							position: 'fixed',
							bottom: '30px',
							left: '20px',
							zIndex: '1000',
						}}
						onClick={() => {
							setIsMapView(!isMapView);
							console.log('clicked');
						}}
					>
						רשימה <FormatListBulletedIcon sx={{ ml: 1 }} />
					</Fab>
				) : (
					<Fab
						variant="extended"
						sx={{
							position: 'fixed',
							bottom: '30px',
							left: '20px',
							zIndex: '10000',
						}}
						onClick={() => {
							setIsMapView(!isMapView);
							console.log('clicked');
						}}
					>
						מפה <MapIcon sx={{ ml: 1 }} />
					</Fab>
				))}
		</div>
	);
}
